import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Check if we're on a marketing page or other non-app pages
    const isMarketingPage =
      pathname.startsWith('/marketing') ||
      pathname === '/' ||
      pathname.startsWith('/terms') ||
      pathname.startsWith('/privacy') ||
      pathname.startsWith('/cookies') ||
      pathname.startsWith('/request-organization') ||
      pathname.startsWith('/payment-') ||
      pathname.startsWith('/login') ||
      pathname.startsWith('/forgot-password') ||
      pathname.startsWith('/reset-password');

    const rootElement = document.getElementById('root');

    // For marketing and auth pages, we need to enable overflow
    if (isMarketingPage) {
      document.documentElement.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
      if (rootElement) {
        rootElement.style.overflow = 'auto';
      }
    } else {
      // For app pages, restore hidden overflow
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      if (rootElement) {
        rootElement.style.overflow = '';
      }
    }

    // Immediate scroll
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    if (rootElement) {
      rootElement.scrollTop = 0;
    }

    // Use requestAnimationFrame to ensure it happens after render
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      if (rootElement) {
        rootElement.scrollTop = 0;
      }
    });

    // Also add a small timeout as a fallback for complex pages
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      if (rootElement) {
        rootElement.scrollTop = 0;
      }
    }, 100);
  }, [pathname]);

  return null;
}
